import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

let initTabsMedia = () => {

  // handle tab switch: toggle active media
  const tabButtons = document.querySelectorAll('.ks-tabs-media button[data-bs-toggle="pill"]');
  tabButtons.forEach(tabBtn => {
    tabBtn.addEventListener('shown.bs.tab', event => {
      const newActivated = event.target.dataset.bsTarget;
      const previousActivated = event.relatedTarget.dataset.bsTarget;

      document.querySelector(previousActivated + '-desktop-media')?.classList.remove('ks-active-tab');
      document.querySelector(newActivated + '-desktop-media')?.classList.add('ks-active-tab');
    });
  });

  // init swiper for tab media
  const swiper = new Swiper(".ks-tabs-media .swiper-tabs-media", {
    modules: [Autoplay, EffectFade],
    speed: 1500,
    spaceBetween: 30,
    effect: "fade",
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    }
  });
};

export default initTabsMedia;
